import React from 'react';

import { ActionLink } from '../../atoms';
import { default as t } from '../../../utils/i18n';
import config from '../../../utils/config';

const HELP_SUPPORT_LINK = config.get('help', 'support_link');
const HELP_EMAIL_ID = config.get('help', 'support_email');
const HELP_LINK = config.get('help', 'support_url');

function DashNavFooter() {
  return (
    <nav className="c-business--footernav">
      <div className="c-business--label c-text-heading-3">
        <ActionLink
          anchor={true}
          href={HELP_SUPPORT_LINK.replace(/\{(.*?)\}/gi,t('dashboard.link.helpAndSupport',true))}
          value={t('dashboard.link.helpAndSupport')}
        />{' '}
        (PDF)
      </div>
      <ActionLink anchor={true} href={HELP_LINK} value={t('dashboard.link.emailus')}></ActionLink>
    </nav>
  );
}

export default DashNavFooter;
